module.exports = __webpack_public_path__ + "img/chess_japanchess10.5c8bcf73.png";